/**
 * 拼单按钮
 */
import React, { FC } from 'react'
import { orderFactory, storeMobx } from 'restaurant'
import { buyTogetherMobx } from '@mobxStore'
import { useHistoryListen, modalLayer, useHistoryNew } from '@utils'
import { Icon } from '@cps'
import { BTConfirmModal } from 'pages/buyTogetherCart/modal'
import { BuyTogetherModal } from '../../../modal'
import { MultiPersonOrderingAPI } from '@api/index'

// interface
interface IProps {}

const BuytogetherBtn: FC<IProps> = () => {
  const history = useHistoryNew()

  const { btEntrie } = buyTogetherMobx

  const handleBuyTogetherBtnClick = async (from?: string) => {
    const data = buyTogetherMobx.getStorage()
    if (data) {
      const { ordersId, buyTogetherId } = data
      if (ordersId) {
        const res = await orderFactory.getOrder(ordersId)
        if (['Pending', 'Paying'].includes(res.result?.status)) {
          showBTConfirmModal(data, from)
        } else {
          showBuyTogetherModal(from)
          buyTogetherMobx.delStorage()
        }
      } else {
        const ownerId = buyTogetherId?.split('_')[2]
        const res = await MultiPersonOrderingAPI.getMultiCart({ storeId: 0, tableCode: 0, roomKey: buyTogetherId })
        const user = res?.user || {}
        if (user[ownerId]?.personId) {
          showBTConfirmModal(data, from)
        } else {
          showBuyTogetherModal(from)
          buyTogetherMobx.delStorage()
        }
      }
    } else {
      showBuyTogetherModal(from)
    }
  }

  const showBTConfirmModal = (data, from?: string) => {
    const { storeInfo, ordersId } = data
    modalLayer(BTConfirmModal, {
      title: i18n.t('menu.buyTogetherTip.tipHaving'),
      desc: i18n.t('menu.buyTogetherTip.tipHavingDesc'),
      confirmText: i18n.t('menu.buyTogetherTip.continueBuy'),
      cancelText: i18n.t('menu.buyTogetherTip.resetBuy'),
    }, 'buyTogetherConfirmModal').then((res: any) => {
      location.href = `/buyTogetherCart?ct=brand&b=${storeInfo.brandId || Config.BRANDID}&s=${storeInfo.storeId || Config.STOREID || 0}&bt=${data.buyTogetherId}`
    }).catch(async (status: any) => {
      // status && multiPersonMobx.delCurrentPersonInfo()
      if (status) {
        buyTogetherMobx.delStorage()
        setTimeout(() => {
          showBuyTogetherModal(from)
        }, 300)
      }
    })
  }

  const showBuyTogetherModal = (from?: string) => {
    // 打开拼单弹层
    modalLayer(BuyTogetherModal, {
      from
    }, 'buyTogetherModal').then(() => {}).catch((err) => {
      if (err === 'close') {
        history.replace('/menu')
      }
    })
  }

  useHistoryListen((pathname: string) => {
    if (pathname === '/menu') {
      // 自动打开拼单弹层
      setTimeout(() => {
        buyTogetherMobx.canStartBuyTogether && (buyTogetherMobx.isOpen || buyTogetherMobx.canAutoStartOpen) && handleBuyTogetherBtnClick()
      }, 200)
    }
  })

  return (
    buyTogetherMobx.canStartBuyTogether ? (
      <div className='waterfall-bt-wrap'>
        <div className='bt-btn-wrapper waterfall-bt-btn' data-cypid='click-buytogether-bar' onClick={() => handleBuyTogetherBtnClick('btn')}>
          <div className='bt-icon'>
            {btEntrie.mode === 0 ? <Icon icon='dicon' name={String(btEntrie.icon)} /> : <img src={btEntrie.pic} />}
          </div>
          <div className='name'>{btEntrie.name || i18n.t('menu.buyTogetherMenu')}</div>
        </div>
      </div>
    ) : null
  )
}
export default BuytogetherBtn
